<template>
  <div>
    <page-header
      has-return
      :page="page"
      right-side-class="col-md d-flex align-items-end mb-2"
      @onReturn="$router.back"
    />
    <div class="mt-3">
      <board class="mb-3" :details="board" />
      <q-tab :active-tab="activeTab">
        <q-tab-item :tabindex="0" title="Terapias" @click="setCurrentTab(0)">
          <therapies
            v-if="academicYears?.length"
            :academic-years="academicYears"
            :referral="referral"
          />
        </q-tab-item>
        <q-tab-item
          lazy
          :tabindex="1"
          title="Evaluaciones"
          @click="setCurrentTab(1)"
        >
          <evaluations :student-id="referral?.studentSie" />
        </q-tab-item>
        <q-tab-item lazy :tabindex="2" title="PEI" @click="setCurrentTab(2)">
          <pei-history :student-id="referral?.studentSie" />
        </q-tab-item>
      </q-tab>
    </div>
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import Board from 'Board';
import { QTab, QTabItem } from '@/components/common/q-tabs';
import { Therapies, PeiHistory, Evaluations } from './components/record';

import {
  getRecord,
  getAcademicYearWithDocuments,
} from '@/modules/shared/studentreferral.api';

const TABS = Object.freeze({
  Therapies: 0,
  Evaluations: 1,
  PEI: 2,
});

export default {
  components: {
    PageHeader,
    Board,
    QTab,
    QTabItem,
    PeiHistory,
    Evaluations,
    Therapies,
  },
  data: () => ({
    activeTab: TABS.Therapies,
    referral: {},
    academicYears: [],
  }),
  computed: {
    page() {
      return {
        icon: 'fas fa-file-alt',
        title: 'Expediente del Referido',
        routes: [
          'Inicio',
          'Proveedor',
          'Manejo de Referidos',
          'Seguimiento',
          'Expediente del Referido',
        ],
      };
    },
    board() {
      return [
        [
          {
            label: 'Número de Referido:',
            icon: 'fas fa-calendar-exclamation',
            data: this.referral?.referralNumber,
          },
          {
            label: 'Tipo de Servicio:',
            icon: 'fas fa-ballot-check',
            data: this.referral?.disciplineType?.name,
          },
          {
            label: 'Estudiante:',
            icon: 'fas fa-address-book',
            data: this.referral?.studentFullName,
          },
          {
            label: 'SIE:',
            icon: 'fas fa-file-alt',
            data: this.referral?.studentSie,
          },
        ],
      ];
    },
    studentServiceId() {
      return Number(this.$route.params.studentServiceId);
    },
    tabParam() {
      return Number(this.$route.query.tab ?? TABS.Therapies);
    },
  },
  async mounted() {
    await this.initData();
  },
  methods: {
    async initData() {
      await this.getRecordInfo();
      await this.getAcademicYears();
      this.activeTab = this.tabParam;
    },
    async getRecordInfo() {
      const { data } = await getRecord(this.studentServiceId);
      this.referral = data;
    },
    async getAcademicYears() {
      const { data } = await getAcademicYearWithDocuments(
        this.referral.studentSie
      );
      let { current, academicYears } = data;
      academicYears.forEach((x) => (x.selected = false));
      current = academicYears.find((x) => x.id === current.id) ?? current;
      current.selected = true;
      this.academicYears = [...new Set([current, ...academicYears])];
    },
    setCurrentTab(tab) {
      const sameRoute = this.tabParam === tab;
      if (sameRoute) return;

      this.activeTab = tab;
      const path = tab ? { query: { tab } } : { name: this.$route.name };
      this.$router.replace(path);
    },
  },
};
</script>
